/**
 * @module manifest/recalcPolicy
 * @description Confirm 后是否触发后端重算 — 由 groupRegistryDefs 派生（PRD §七）
 *
 * 派生结果延迟到首次访问：避免 allGroups → settingGroups → constants → 本模块 的循环依赖。
 */

import type { IGroupDefinition } from './defineGroup';
import { definitionsToNotCalculateKeys } from './defineGroup';

/**
 * 不在 defineGroup.uploadKeys 中、但 draft/base 可能出现的字段
 * - `yAxisRangeSwitch2`：历史组合图只读兼容字段
 */
export const EXTRA_NOT_RECALC_ON_CONFIRM_KEYS = [
  'yAxisRangeSwitch2',
] as const;

/** 图例系列排序等 — 明确需重算，勿加入 NOT_CALCULATE_KEYS */
export const LEGEND_SORT_CALCULATE_KEYS = [
  'sort_series',
  'series_order',
  'series_sorts',
] as const;

let registeredGroupDefsCache: readonly IGroupDefinition[] | undefined;
let notCalculateKeysCache: ReadonlySet<string> | undefined;

function loadRegisteredGroupDefs(): readonly IGroupDefinition[] {
  if (!registeredGroupDefsCache) {
    // eslint-disable-next-line @typescript-eslint/no-var-requires, global-require
    const mod = require('./groupRegistryDefs') as typeof import('./groupRegistryDefs');
    registeredGroupDefsCache = mod.ALL_REGISTERED_GROUP_DEFS;
  }
  return registeredGroupDefsCache;
}

/** 延迟派生，供契约测试与调试直接读取 */
export function getNotCalculateKeys(): ReadonlySet<string> {
  if (!notCalculateKeysCache) {
    notCalculateKeysCache = definitionsToNotCalculateKeys(
      loadRegisteredGroupDefs(),
      [...EXTRA_NOT_RECALC_ON_CONFIRM_KEYS],
    );
  }
  return notCalculateKeysCache;
}
